import { Business as BusinessIcon } from '@mui/icons-material';
import { Box, Container, Grid, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: '#263238',
                color: '#fff',
                py: 4,
                mt: 8,
            }}
        >
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <BusinessIcon sx={{ mr: 1, fontSize: 28 }} />
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                AI Solutions
                            </Typography>
                        </Box>
                        <Typography variant="body2" sx={{ opacity: 0.8 }}>
                            Empowering businesses through strategic excellence and innovative solutions.
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Quick Links
                        </Typography>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Link to="/" style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none' }}>
                                Home
                            </Link>
                            <Link to="/about" style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none' }}>
                                About
                            </Link>
                            <Link to="/services" style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none' }}>
                                Services
                            </Link>
                            <Link to="/contact" style={{ color: 'rgba(255,255,255,0.8)', textDecoration: 'none' }}>
                                Contact
                            </Link>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Contact Info
                        </Typography>
                        <Typography variant="body2" sx={{ opacity: 0.8 }}>
                            Email: info@apexconsulting.com
                        </Typography>
                        <Typography variant="body2" sx={{ opacity: 0.8 }}>
                            Phone: (555) 123-4567
                        </Typography>
                        <Typography variant="body2" sx={{ opacity: 0.8 }}>
                            Address: 123 Business Ave, Suite 456, New York, NY 10001
                        </Typography>
                    </Grid>
                </Grid>
                <Box sx={{ textAlign: 'center', mt: 4, pt: 3, borderTop: '1px solid rgba(255,255,255,0.2)' }}>
                    <Typography variant="body2" sx={{ opacity: 0.7 }}>
                        © 2025 Apex Consulting. All rights reserved.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;